import { useContext, useEffect, useState } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import theme from "styles/theme";
import { AppRouter } from "./router";
import { Store } from "./middleware";
import { Menu } from "./components/Menu";
import { DataState } from "./context/Data/state";
import { Loader } from "./components/Loader";
import { mobileSize } from "./utils/responsive";
// import PickupPartnerProvider from "./components/PickupPartnerProvider";
import { UserState } from "./context/User/state";
import { BrandState } from "./context/Brand/state";
import "../src/global/google/firebase/messaging";
import Cookie from "./utils/cookie";
import { ACCESS_TOKEN } from "./constants";
import { firebaseMessaging } from "./global/google/firebase/messaging";
import { WebSocketState } from "./context/WebSocket/state";
import { MenuContext } from "./context/Menu/context";
import { usePageGradientBg } from "./hooks/usePageGradientBg";
import gradientBg from "./assets/img/gradientBackground.png";
import BatchIntegrationWebsocket from "./components/BatchIntegrationWebsocket";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import "./styles/toast.css";

function App() {
  const [accessToken] = useState(Cookie.get(ACCESS_TOKEN));
  const { isHideMenu } = useContext(MenuContext);
  const { user: storeUser } = useContext(Store);
  const { isGradientBg } = usePageGradientBg();

  useEffect(() => {
    if (accessToken) firebaseMessaging();
  }, []);

  const useStyles = makeStyles(() => ({
    root: {
      display: "grid",
      gridTemplateColumns: () => {
        if (!storeUser) return "auto";
        return isHideMenu ? "106px 1fr" : "265px 1fr";
      },
      transition: ".25s",
      height: "inherit",
      [theme.breakpoints.down(mobileSize)]: {
        display: "block",
        width: "100%",
      },
    },
    gradientBg: {
      background: `url(${gradientBg}) no-repeat center`,
      backgroundSize: "cover",
    },
    content: {
      flexGrow: 1,
      padding: 24,
      height: "calc(100% - 48px)",
      maxWidth: "100%",
      overflowY: "scroll",
      [theme.breakpoints.down(mobileSize)]: {
        width: "auto",
        display: "block",
        padding: 8,
        height: "calc(100% - 96px)",
      },

      "& > .MuiGrid-spacing-xs-4 ": {
        width: "unset",
        margin: 0,
      },
    },
  }));
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <Store.Consumer>
        {({ user, isLoading }) => (
          <div
            className={clsx(classes.root, {
              [classes.gradientBg]: isGradientBg,
            })}
          >
            <UserState user={user}>
              {isLoading &&
                !document.querySelector("div[role='presentation']") && (
                  <Loader in={user} />
                )}
              <BrandState>
                <WebSocketState>
                  {/* Drawer */}
                  {user && <Menu user={user} />}

                  <main className={classes.content}>
                    <DataState>
                      <AppRouter user={user} />
                      {/* <PickupPartnerProvider user={user} /> */}
                    </DataState>
                  </main>
                  <BatchIntegrationWebsocket />
                  <ToastContainer />
                </WebSocketState>
              </BrandState>
            </UserState>
          </div>
        )}
      </Store.Consumer>
    </ThemeProvider>
  );
}

export default App;
